<template>
	<!-- 사용 예시 : qms/FreeForm/Content/Table/TableDetailInfo.vue -->
	<div class="qms-img-upload">
		<template v-if="!!hasFileId && !url">
			<span>{{ getMessage_('QWCC001817') }}</span>
		</template>
		<template v-else-if="!!url">
			<div class="qms-img-upload__pic position-relative m-auto p-0" :style="`width: ${width}; height: ${height}; `">
				<template v-if="isEditable">
					<span class="qms-img-upload__pic__badges position-absolute" @click="deleteAction"> <i class="icon-sf-trash" /></span>
				</template>
				<template v-if="!isNew">
					<span class="qms-img-upload__pic__badges position-absolute" style="right: 45px" @click="downloadAction">
						<i class="icon-sf-file" />
					</span>
				</template>
				<el-image :src="url" :preview-src-list="srcList" style="width: 100%; height: 100%" fit="fit">
					<div slot="placeholder" class="image-slot">Loading<span class="dot">...</span></div>
				</el-image>
			</div>
		</template>
		<template v-else-if="!disabled">
			<input type="file" :id="id" accept="image/jpeg,image/gif,image/png" ref="imgInputRef" @change="uploadImgAction" />
			<label :for="id" class="qms-img-upload__add">
				<i class="icon-sf-circle-plus" />
			</label>
		</template>
	</div>
</template>

<script>
import { rootComputed, rootMethods } from '@/store/common/helpers';
import { qmsComputed, qmsMethods } from '@/store/qms/helpers';
export default {
	name: 'img-upload',
	props: {
		width: { type: String, default: '100%' },
		height: { type: String, default: '100px' },
		propSeq: { type: String, default: '' }, // 한 화면에서 여러개 쓸 때 구분짓기 위한 구분자
		propSrc: { type: String, default: '' }, // db에서 받은 파일 url 주소
		propFileId: { type: String, default: '' }, //db에서 받은 파일 아이디
		disabled: { type: Boolean, default: false }, //파일 추가 불가능
		isEditable: { type: Boolean, default: true }, //삭제 불가능
		needDupCheck: { type: Boolean, default: false } // 중복 체크가 필요한 컴포넌트인지 (필요할 경우 imgDupCheck 에밋 필수)
	},
	data() {
		return {
			isNew: true,
			url: '',
			hasFileId: '',
			id: Math.random() * 10000 + 1,
			file: {}
		};
	},
	created() {
		if (this.propSrc) {
			this.url = this.propSrc;
			this.isNew = false;
		}
	},
	computed: {
		...rootComputed,
		...qmsComputed,
		srcList() {
			return [this.url];
		}
	},
	watch: {
		propSrc() {
			this.url = this.propSrc;
		},
		propFileId() {
			this.hasFileId = this.propFileId;
		}
	},

	methods: {
		...rootMethods,
		...qmsMethods,
		uploadImgAction({ target }) {
			this.isNew = true;
			if (target?.files[0]) {
				this.file = target?.files[0];
				if (this.needDupCheck) {
					this.$emit('imgDupCheck', { seq: this.propSeq, file: this.file });
				} else this.imgUpload();
			}
		},
		async imgUpload() {
			const reader = new FileReader();
			reader.readAsDataURL(this.file);
			reader.onload = () => {
				this.url = reader.result;
			};
			this.$emit('imgUpload', { seq: this.propSeq, file: this.file });
		},
		async deleteAction() {
			try {
				this.$sf_toggleLoading(true);
				if (this.propFileId) {
					const { code, messageCd } = await this.deleteFile_({ fileId: this.propFileId, fileSeq: 1 });
					if (code === 0 || code === 3) {
						this.$sf_toast({
							type: code === 0 ? 'ok' : 'error',
							message: this.getMessage_(messageCd)
						});
					}
					if (code === 0) {
						this.initImg();
						this.$emit('deleteImg', { seq: this.propSeq });
					}
				} else {
					this.initImg();
					this.$emit('deleteImg', { seq: this.propSeq });
				}
			} catch (error) {
				this.$sf_toast({ type: 'error', message: this.getMessage_('QWCC001404') });
			} finally {
				this.$sf_toggleLoading(false);
			}
		},
		downloadAction() {
			this.$emit('imgDownload', { seq: this.propSeq });
		},
		//ref 이용하여 초기화 할 때 쓸 수 있음.
		initImg() {
			this.isNew = false;
			this.id = Math.random() * 10000 + 1;
			this.url = '';
			this.file = {};
		}
	}
};
</script>

<style lang="scss" scoped>
.qms-img-upload {
	text-align: center !important;
	.qms-img-upload__add {
		font-size: 60px;
		opacity: 0.8;
		cursor: pointer;
		&:hover {
			opacity: 1;
		}
	}
	input[type='file'] {
		display: none !important;
	}
	.qms-img-upload__pic {
		overflow: hidden;
		img {
			width: 100%;
			height: 100%;
			object-position: center !important;
		}

		&:hover {
			.qms-img-upload__pic__badges {
				opacity: 1;
			}
		}

		.qms-img-upload__pic__badges {
			z-index: 10;
			top: 0px;
			right: 10px;
			opacity: 0;
			color: rgb(187, 187, 187);
			font-size: 26px;
			font-weight: normal;
			cursor: pointer;
			& i:hover {
				color: rgb(230, 229, 229);
			}
		}
	}
}
</style>
